import * as TypeUtils from './_typeUtils';

const Utils = { TypeUtils };

export default Utils;
